module.exports = __webpack_public_path__ + "static/media/AutoCAD Raster Design.d5c2c0ab.png";